import LovrFire from '../lovrfire'
import LovrException from './LovrException'
import firebase from 'firebase'


export const followUser = async (id) => {
    // fetching logged-in user uid
    const uid = LovrFire.auth().currentUser.uid;
    const checkAlreadyFollowed = await LovrFire.firestore().collection('users').doc(LovrFire.auth().currentUser.uid).collection('following').doc(id).get();
    if (checkAlreadyFollowed.exists)
        return;
    await LovrFire.firestore().collection('users').doc(uid).collection('following').doc(id).set({
        uid: id
    });
    await LovrFire.firestore().collection('users').doc(id).collection('followers').doc(uid).set({
        uid: uid
    });

    const userRef = LovrFire.firestore().collection('users').doc(uid);
    const remoteUserRef = LovrFire.firestore().collection('users').doc(id);

    LovrFire.firestore().runTransaction(async tx => {
        return tx.get(userRef).then(user => {
            if (!user.exists) {
                throw 'Error'
            }
            var newFollowingCount = user.data().followingCount + 1
            tx.update(userRef, {
                followingCount: newFollowingCount,
            });
        }).then(v => {}).catch(e => {})
    })

    LovrFire.firestore().runTransaction(async tx => {
        return tx.get(remoteUserRef).then(rUser => {
            if (!rUser.exists) {
                throw 'Error'
            }
            var newFollowersCount = rUser.data().followersCount + 1
            tx.update(remoteUserRef, {
                followersCount: newFollowersCount,
            });
        }).then(v => {
            return v;
        }).catch(e => {})
    })
}

export const unFollowUser = async (id) => {
    // fetching logged-in user uid
    const uid = LovrFire.auth().currentUser.uid;
    await LovrFire.firestore().collection('users').doc(uid).collection('following').doc(id).delete()
    await LovrFire.firestore().collection('users').doc(id).collection('followers').doc(uid).delete()

    const userRef = LovrFire.firestore().collection('users').doc(uid);
    const remoteUserRef = LovrFire.firestore().collection('users').doc(id);

    LovrFire.firestore().runTransaction(async tx => {
        return tx.get(userRef).then(user => {
            if (!user.exists) {
                throw 'Error'
            }
            var newFollowingCount = user.data().followingCount - 1
            tx.update(userRef, {
                followingCount: newFollowingCount,
            });
        }).then(v => {}).catch(e => {})
    })

    LovrFire.firestore().runTransaction(async tx => {
        return tx.get(remoteUserRef).then(rUser => {
            if (!rUser.exists) {
                throw 'Error'
            }
            var newFollowersCount = rUser.data().followersCount - 1
            tx.update(remoteUserRef, {
                followersCount: newFollowersCount,
            });
        }).then(v => {
            return v;
        }).catch(e => {})
    })
}

export const starUser = async (id) => {
    const uid = LovrFire.auth().currentUser.uid;
    const checkAlreadyStarred = await LovrFire.firestore().collection('users')
    .doc(LovrFire.auth().currentUser.uid).collection('starred').doc(id).get();
    if (checkAlreadyStarred.exists)
        return 'STARRED ALREADY';
    await LovrFire.firestore().collection('users').doc(uid).collection('starred').doc(id).set({
        uid: id
    });
}

export const unStarUser = async (id) => {
    const uid = LovrFire.auth().currentUser.uid;
    await LovrFire.firestore().collection('users').doc(uid).collection('starred').doc(id).delete()
}

export const getStarredUsers = async (id, observer) => {
    const uid = id;
    try{
    return LovrFire.firestore().collection('users').doc(uid).collection('starred').onSnapshot(observer);
    }catch(e){
        
    }
}


export const isStarred = async (remoteId) => {
    let flag = 0;
    const res = await LovrFire.firestore().collection('users')
    .doc(LovrFire.auth().currentUser.uid).collection('starred').get();
    for (var i = 0; i < res.docs.length; i++) {
        if (res.docs[i].data().uid == remoteId.id) {
            flag = 1;
            break;
        }
    }
    if (flag == 0) return false;
    else return true;
}

export const isFollowed = async (remoteId) => {
    let flag = 0;
    const res = await LovrFire.firestore().collection('users').doc(LovrFire.auth().currentUser.uid).collection('following').get();
    for (var i = 0; i < res.docs.length; i++) {
        if (res.docs[i].data().uid == remoteId.id) {
            flag = 1;
            break;
        }
    }
    if (flag == 0) return false;
    else return true;
}

export const getFollowing = async(id) => {
    try{
    const res = await LovrFire.firestore().collection('users')
    .doc(id).collection('following').get();
    return res.docs;
    }catch(e){}

}